import { Handle, Position } from '@xyflow/react';
import { Clock } from 'lucide-react';

const DelayNode = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border-2 border-amber-400 w-64 overflow-hidden">
      <div className="bg-amber-400 p-2 flex items-center gap-2">
        <Clock className="h-4 w-4 text-white" />
        <span className="text-xs font-bold text-white uppercase tracking-wider">
          Delay
        </span>
      </div>
      <div className="p-4">
        <div className="text-sm font-semibold text-gray-900 mb-1">Wait for</div>
        <div className="text-xs text-gray-500">
          {data.duration || '5'} {data.unit || 'minutes'}
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 bg-gray-300 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className="w-3 h-3 bg-amber-400 border-2 border-white"
      />
    </div>
  );
};

export default DelayNode;
